(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-gallery')) {
    class ProductGallery extends HTMLElement {
      connectedCallback() {
        this.placeCards();
        this.bindSlideshow();

        if (!this.querySelector('[data-gallery-card]')) {
          requestAnimationFrame(() => {
            this.placeCards();
            this.bindSlideshow();
          });
        }
      }

      disconnectedCallback() {
        this.slideshow?.removeEventListener('slideChanged', this.onSlideChanged);
      }

      placeCards() {
        const target = this.querySelector('[data-gallery-cards]');
        if (!target) return;

        const cards = Array.from(this.querySelectorAll('[data-gallery-card]'));
        const needsPlace = cards.some((card) => card.parentElement !== target);
        if (!needsPlace) return;

        cards.forEach((card, index) => {
          card.hidden = index !== 0;
          target.append(card);
        });
      }

      bindSlideshow() {
        const slideshow = this.querySelector('slideshow-component');
        if (!slideshow || slideshow === this.slideshow) return;

        if (this.slideshow && this.onSlideChanged) {
          this.slideshow.removeEventListener('slideChanged', this.onSlideChanged);
        }

        this.slideshow = slideshow;
        this.onSlideChanged = (event) => {
          this.showCard(event.detail?.currentPage);
        };
        this.slideshow.addEventListener('slideChanged', this.onSlideChanged);
      }

      showCard(page) {
        if (!page || page < 1) return;

        const index = page - 1;

        this.querySelectorAll('[data-gallery-card]').forEach((card, cardIndex) => {
          const active = cardIndex === index;
          card.hidden = !active;

          card.querySelectorAll('video').forEach((video) => {
            if (active && video.autoplay) {
              video.play();
              return;
            }

            video.pause();
          });
        });
      }
    }

    customElements.define('product-gallery', ProductGallery);
  }
  } catch(e) { console.error(e); }
})();

})();
